<template>
  <div
    class="author-affiliations"
  >
    <div class="author-affiliations__tag-layout">
      <div
        v-if="modelValue.length > 0"
        class="author-affiliations__tag-list"
      >
        <ul>
          <li
            v-for="(affiliation, affiliationIndex) in modelValue"
            :key="affiliationIndex"
            class="author-affiliations__item"
          >
            <UnitTag
              class="unit-tag--adv-search"
              :unit="affiliation"
              @remove="removeAffiliation(affiliationIndex)"
            />
          </li>
        </ul>
      </div>
      <button
        v-show="selectableUnits.length > 0 && !addingAffiliation"
        class="btn--link btn--lg"
        @click="addAffiliation"
      >
        <span class="btn__icon btn__icon--bulletpoint">
          <svg
            width="9"
            height="9"
            viewBox="0 0 11 11"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              fill="currentcolor"
              fill-rule="evenodd"
            >
              <rect
                x=".8033009"
                y="4.3033009"
                width="10"
                height="2"
                rx="1"
              />
              <rect
                transform="rotate(90 5.801068 5.301068)"
                x=".8010678"
                y="4.3010678"
                width="10"
                height="2"
                rx="1"
              />
            </g>
          </svg>
        </span>
        <span
          class="btn__text"
        >
          {{ t((modelValue.length > 0)
            ? "advancedsearch.add.other.affiliation"
            : "advancedsearch.add.affiliation") }}
        </span>
      </button>
    </div>
    <div
      v-show="addingAffiliation"
      class="f-field"
    >
      <div
        ref="selectUnit"
        class="f-field--info author-affiliations__select"
      >
        <input
          v-model="searchAffiliation"
          class="f-field__input"
          :placeholder="t('affiliations.placeholder')"
          type="text"
          :aria-label="t('affiliations.ariaLabel')"
        >
        <div class="card author-affiliations__select-list">
          <button
            v-for="option in selectableUnits"
            :key="option.id"
            class="card-row"
            style="width: 100%;"
            @click.prevent="choseAffiliation(option)"
          >
            <div class="card-row__text">
              <p class="small">
                <UnitBreadcrumb :unit="option" />
              </p>
              <p>
                <strong>{{ option.name }}</strong>
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UnitTag from '#src/components/utils/UnitTag.vue'
import UnitBreadcrumb from '#src/components/units/UnitBreadcrumb.vue'
import { normalize } from '#src/utils/search-helpers'
import { createFocusTrap } from 'focus-trap'
import { useI18n } from 'vue-i18n'

export default {
  components: {
    UnitTag,
    UnitBreadcrumb
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    unitsList: {
      type: Array,
      required: true
    },
    startOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  setup() {
    const { t } = useI18n({
      fallbackWarn: false,
      silentTranslationWarn: true,
      silentFallbackWarn: true,
      messages: {
        pt: {
          affiliations: {
            placeholder: 'Afiliações referentes à publicação',
            ariaLabel: 'Afiliações referentes à publicação'
          }
        },
        en: {
          affiliations: {
            placeholder: 'Affiliations of the publication',
            ariaLabel: 'Affiliations of the publication'
          }
        }
      }
    })
    return { t }
  },
  data() {
    return {
      addingAffiliation: false,
      searchAffiliation: '',
      trap: null
    }
  },
  computed: {
    selectableUnits() {
      const availableUnits = this.unitsList.filter(unit => !this.modelValue.map(u => u.id).includes(unit.id))

      if (this.searchAffiliation) {
        const query = normalize(this.searchAffiliation)
        return availableUnits.filter(unit =>
          normalize(unit.name).includes(query) || normalize(unit.acronym).includes(query))
      }
      return availableUnits
    }
  },
  async mounted() {
    if (this.startOpen && this.modelValue.length === 0) {
      await this.addAffiliation()
    }
  },
  methods: {
    async addAffiliation() {
      this.addingAffiliation = true
      // This awaits for the input to show
      await this.$nextTick()
      this.trap = createFocusTrap(this.$refs.selectUnit, {
        clickOutsideDeactivates: true,
        onDeactivate: () => {
          this.addingAffiliation = false
          this.searchAffiliation = ''
        }
      })
      this.trap.activate()
    },
    choseAffiliation(affiliation) {
      this.addingAffiliation = false
      this.modelValue.push(affiliation)
      this.trap.deactivate()
      this.$emit('change', this.modelValue)
    },
    removeAffiliation(indexToRemove) {
      this.modelValue.splice(indexToRemove, 1)
      if (this.startOpen && this.modelValue.length === 0) {
        this.addingAffiliation = true
      }
      this.$emit('change', this.modelValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.author-affiliations {
  display: flex;
  flex-flow: column nowrap;
  align-self: center;
  justify-content: stretch;
  overflow: hidden;

  .f-field {
    margin: 0;
    padding-left: 0;
  }
}

.author-affiliations__tag-layout {
  overflow: hidden;
}

.author-affiliations__tag-list {
  margin-bottom: 0.75rem;
}

.author-affiliations__item + .author-affiliations__item {
  margin-top: 1rem;
}
</style>
